<template>
  <el-dialog
    :title="$t('alarmPushRule.ruleDetail')"
    :visible.sync="dialogBind"
    :before-close="doClose"
    width="80%"
    top="5%"
    class="abow_dialog"
  >
    <el-form
      ref="alarmPushBindform"
      :model="alarmPushBindform"
      label-width="180px"
      style="height: 100%"
    >
      <template>
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          @click="addHandle"
          style="margin-bottom: 10px; margin-top: 10px"
          >{{ $t("button.add") }}</el-button
        >
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          @click="showBatchAddDialog"
          style="margin-bottom: 10px; margin-top: 10px"
          >{{ $t("button.batchAdd") }}</el-button
        >
        <div class="DBDiv">
          <div class="tableDiv">
            <el-form ref="formBind" :model="formBind" :rules="rules">
              <el-table
                :data="formBind.alarmRuleBindTableTemp"
                ref="CCNTable"
                stripe
                class="formSTable ccntable"
                :empty-text="$t('desc.noData')"
                :height="CCNheight"
              >
                <el-table-column
                  type="index"
                  :label="$t('title.serialNumber')"
                  width="60"
                >
                </el-table-column>
                <el-table-column
                  :label="$t('title.controllCcn')"
                  min-width="180px"
                  prop="ccn"
                >
                  <template slot-scope="scope">
                    <el-form-item
                      style="margin-top: 0px"
                      :prop="'alarmRuleBindTableTemp.' + scope.$index + '.ccn'"
                      :rules="rules.ccn"
                    >
                      <el-select
                        :ref="scope.row.ccn"
                        filterable
                        v-model="scope.row.ccn"
                        @change="changeCcn(scope.$index)"
                        style="width: 100%"
                      >
                        <el-option
                          v-for="item in ccnOption[scope.$index]"
                          :label="item"
                          :value="item"
                          :key="item"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column
                  :label="$t('title.ccnVersion')"
                  min-width="120px"
                  prop="ccnVersion"
                >
                  <template slot-scope="scope">
                    <el-form-item
                      style="margin-top: 0px"
                      :prop="'alarmRuleBindTableTemp.' + scope.$index + '.ccnId'"
                      :rules="rules.ccnId"
                    >
                      <el-select
                        :ref="scope.row.ccnId"
                        v-model="scope.row.ccnId"
                        @change="changeCcnVersion(scope.$index)"
                        style="width: 100%"
                      >
                        <el-option
                          v-for="item in ccnVersionList[scope.$index]"
                          :label="item.ccnVersion"
                          :value="item.ccnId"
                          :key="item.ccnId"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column
                  :label="$t('alarmPushRule.range')"
                  min-width="120px"
                  prop="ccnVersion"
                >
                  <template slot-scope="scope">
                    <el-form-item
                      style="margin-top: 0px"
                      :prop="'alarmRuleBindTableTemp.' + scope.$index + '.rangeType'"
                      :rules="rules.rangeType"
                    >
                      <el-select
                        :ref="scope.row.rangeType"
                        v-model="scope.row.rangeType"
                        style="width: 100%"
                      >
                        <el-option
                          :label="$t('alarmPushRule.all')"
                          value="all"
                        ></el-option>
                        <el-option
                          :label="$t('alarmPushRule.customize')"
                          value="customize"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('title.operate')" width="100px">
                  <template slot-scope="scope">
                    <el-button
                      type="primary"
                      icon="el-icon-edit"
                      circle
                      size="mini"
                      v-if="scope.row.rangeType == 'customize' && scope.row.ccnId"
                      @click="showGatherDialog(scope.row)"
                    ></el-button>
                    <template>
                      <el-popconfirm
                        placement="top"
                        :confirmButtonText="$t('button.confirm')"
                        :cancelButtonText="$t('button.cancel')"
                        icon="el-icon-info"
                        iconColor="red"
                        :title="$t('title.confirmDelete')"
                        @confirm="deleteHandel(scope)"
                      >
                        <el-button
                          icon="el-icon-delete"
                          circle
                          size="mini"
                          slot="reference"
                          type="danger"
                        ></el-button>
                      </el-popconfirm>
                    </template>
                  </template>
                </el-table-column>
              </el-table>
            </el-form>
          </div>
        </div>
        <el-form-item style="margin-bottom: 0; margin-top: 10px">
          <el-button type="success" :loading="loading" @click="onSubBtn()">{{
            $t("button.confirm")
          }}</el-button>
          <el-button @click="doClose">{{ $t("button.cancel") }}</el-button>
        </el-form-item>
      </template>
    </el-form>
  </el-dialog>
</template>
<script>
import { getCcnWithVersionList, getAlarmPushRuleCcn, getAllAlarmPushRuleCcn } from "../../../api/api";
export default {
  name: "index",
  props: {
    dialogBind: false,
    alarmPushRuleId: "",
    ruleId: "",
    gatherReturnIdList: [],
    loading: false,
    batchAddCcnArr:[],
  },
  data() {
    return {
      rules: {
        ccn: {
          required: true,
          message: this.$t("tips.needed"),
          trigger: "blur",
        },
        ccnId: {
          required: true,
          message: this.$t("tips.needed"),
          trigger: "blur",
        },
        rangeType: {
          required: true,
          message: this.$t("tips.needed"),
          trigger: "blur",
        },
      },
      alarmPushBindform: {
        ccnKeyword: "",
      },
      alarmRuleBindTable: [],
      alarmRuleBindTableTemp: [],
      CCNheight: "auto",
      ccnList: [],
      ccnOption: [],
      ccnVersionList: {},
      formBind: {
        alarmRuleBindTableTemp: [],
      },
      ccnRelList:[],
    };
  },
  watch: {
    dialogBind: {
      async handler(newValue, oldValue) {
        if (newValue === true) {
          this.alarmRuleBindTable = new Array();
          this.formBind.alarmRuleBindTableTemp = new Array();
          this.getAllAlarmPushRuleCcn();
          await this.getAlarmPushRuleCcn();
          this.setHeight();
        }
      },
      deep: true,
    },
    gatherReturnIdList: {
      async handler(newValue, oldValue) {
        this.formBind.alarmRuleBindTableTemp.forEach((element, index) => {
          if (newValue[element.ccnId]) {
            element.alarmInfo = JSON.stringify(newValue[element.ccnId])
          }
        })
      },
      deep: true,
    },
    batchAddCcnArr:{
      async handler(newValue, oldValue) {
        newValue.forEach(element => {
          this.addHandleAuto(element)
        });
        this.changeCcn();
      },
      deep: true,
    }
  },
  created: function () {
    this.getCcnWithVersionList();
    window.onresize = () => {
      this.setHeight();
    };
  },
  methods: {
    
    async getCcnWithVersionList() {
      let res = await getCcnWithVersionList();
      this.ccnList = res.result;
      // this.ccnOption = this.unique(res.result.map((a) => a.ccn));
      this.changeCcn();
    },
    async getAllAlarmPushRuleCcn(){
      let res = await getAllAlarmPushRuleCcn();
      this.ccnRelList = res.result;
    },
    changeCcn(index) {
      if (index) {
        let obj = {
          ccn:this.formBind.alarmRuleBindTableTemp[index].ccn,
          ccnVersion: "",
          rangeType: "",
          ccnId: "",
          alarmInfo: "[]",
        };
        this.$set(this.formBind.alarmRuleBindTableTemp,index,obj)
      }
      this.ccnVersionList = new Array();
      this.ccnOption = new Array();
      let selCcnIdList = this.formBind.alarmRuleBindTableTemp.filter(a=>a.ccnId).map((a) => a.ccnId);
      this.formBind.alarmRuleBindTableTemp.forEach((element, index) => {
        //去除所有已选择的值
        let ccnVersionList = this.ccnList.filter(
          (a) => a.ccn == element.ccn && !selCcnIdList.some((x) => a.ccnId == x)
        );
        //将该下拉框选择的值添加进下拉框列表
        if (element.ccnId&&!ccnVersionList.some(a=>a.ccnId ==element.ccnId)) {
          ccnVersionList.push(this.ccnList.find((a) => a.ccnId == element.ccnId));
        }
        this.ccnVersionList.push(ccnVersionList);
        //过滤ccn下拉框
        let ccnList = this.unique(this.ccnList.filter(
          (a) => !selCcnIdList.some((x) => a.ccnId == x)
        ).map(a=>a.ccn));
        
        if (element.ccn && !ccnList.some(a=> element.ccn == a)) {
          ccnList.unshift(element.ccn)
        }
        ccnList.sort()
        this.ccnOption.push(ccnList);
      });
    },
    unique(arr) {//去重
      const res = new Map();
      return arr.filter((a) => !res.has(a) && res.set(a, 1));
    },
    changeCcnVersion(index) {
      let obj = {
          ccn:this.formBind.alarmRuleBindTableTemp[index].ccn,
          ccnVersion: this.formBind.alarmRuleBindTableTemp[index].ccnVersion,
          rangeType: "",
          ccnId: this.formBind.alarmRuleBindTableTemp[index].ccnId,
          alarmInfo: "[]",
        };
        this.$set(this.formBind.alarmRuleBindTableTemp,index,obj)
      this.changeCcn();
    },
    async getAlarmPushRuleCcn() {
      let data = {
        id: this.ruleId,
        keyword: this.alarmPushBindform.ccnKeyword,
      };
      let res = await getAlarmPushRuleCcn(data);
      this.alarmRuleBindTable = res.result;
      this.alarmRuleBindTable.forEach((element) => {
        if (element.alarmInfo.length == 2) {
          element.rangeType = "all";
        } else {
          element.rangeType = "customize";
        }
      });
      this.formBind.alarmRuleBindTableTemp = JSON.parse(
        JSON.stringify(this.alarmRuleBindTable)
      );
      this.changeCcn();
    },
    setHeight() {
      let Height = document.documentElement.clientHeight;
      if (Height > 580) {
        this.CCNheight = document.documentElement.clientHeight * 0.9 - 290;
      } else {
        this.CCNheight = 232;
      }
    },
    showGatherDialog(row) {
      this.$emit("showGatherDialog", true, row);
    },
    showBatchAddDialog(){
      //去除当前窗口所有已经勾选的
      let curCcnIdArr = this.formBind.alarmRuleBindTableTemp.map(a=>a.ccnId)
      //去除其他规则已绑定的ccn
      let otherCcnIdArr = this.ccnRelList.filter(a=>a.ruleId != this.ruleId).map(a=>a.ccnId);
      //合并
      otherCcnIdArr.push(...curCcnIdArr);
      let result = this.ccnList.filter(a=> !otherCcnIdArr.some(x=>x == a.ccnId))
      this.$emit("showBatchAddDialog", true, result);
    },

    onSubBtn() {
      this.$refs["formBind"].validate((valid) => {
        if (valid) {
          this.$emit("onSubBtn", this.formBind.alarmRuleBindTableTemp);
        } else {
          return false;
        }
      });
    },
    async doClose() {
      await this.$emit("dialogVisibleEvent", false);
      this.alarmRuleBindTable = new Array();
      this.formBind.alarmRuleBindTableTemp = new Array();
    },
    addHandle() {
      let obj = {
        ccnVersion: "",
        rangeType: "",
        ccnId: "",
        alarmInfo: "[]",
      };
      this.alarmRuleBindTable.push(obj);
      this.formBind.alarmRuleBindTableTemp.push(obj);
      this.changeCcn();
    },
    addHandleAuto(data) {
      let obj = {
        ccn: data.ccn,
        ccnVersion: data.ccnVersion,
        rangeType: "all",
        ccnId: data.ccnId,
        alarmInfo: "[]",
      };
      this.alarmRuleBindTable.push(obj);
      this.formBind.alarmRuleBindTableTemp.push(obj);
    },
    deleteHandel(scope) {
      this.alarmRuleBindTable.splice(
        this.alarmRuleBindTable.findIndex((a) => a.ccnId == scope.row.ccnId),
        1
      );
      this.formBind.alarmRuleBindTableTemp.splice(
        this.formBind.alarmRuleBindTableTemp.findIndex((a) => a.ccnId == scope.row.ccnId),
        1
      );
      this.changeCcn();
    },
  },
};
</script>
